import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { exclametry_red_dark } from '../../../assets/images';
import { calendar } from '../../../assets/images';

const resetButtonClass =
  'ml-2 inline-flex h-10 items-center justify-center rounded-lg border border-gray-250 bg-white px-4 text-xs font-semibold leading-none text-gray-900 shadow-sm transition hover:border-gray-400 hover:bg-gray-100';
const resetButtonDisabledClass =
  'cursor-default border-gray-250 bg-gray-100 text-gray-400 shadow-none hover:border-gray-250 hover:bg-gray-100';

const DateRangePicker = ({isCurrent, isOverAll, filterDates, contractDates, changeDates = () =>{}}) => {
  const contractStartDate = new Date(moment(contractDates[0], 'YYYY-MM-DD'));
  const contractEndDate = new Date(moment(contractDates[1], 'YYYY-MM-DD'));
  const formattedStartDate = filterDates?.startDate ? moment(filterDates?.startDate, 'YYYY-MM-DD').format('DD MMM YYYY'): moment(contractDates[0], 'YYYY-MM-DD').format('DD MMM YYYY');
  const formattedEndDate = filterDates?.endDate ? moment(filterDates?.endDate, 'YYYY-MM-DD').format('DD MMM YYYY') : moment(contractDates[1], 'YYYY-MM-DD').format('DD MMM YYYY')
  const start_date = filterDates?.startDate ? new Date(moment(filterDates?.startDate, 'YYYY-MM-DD')) : contractStartDate;
  const end_date = filterDates?.endDate ? new Date(moment(filterDates?.endDate, 'YYYY-MM-DD')) : contractEndDate ;
  let isSelectedDateContractStartDate = start_date.getTime() === contractStartDate.getTime();
  let isSelectedDateContractEndDate = end_date.getTime() === contractEndDate.getTime();

  return (
    <>
      <div className='flex justify-between pt-4'>
        <div className='text-sm'>
          {`The utilization data displayed below is from ${formattedStartDate} to ${formattedEndDate}`}
        </div>
        <div className='flex'>
          <div className='flex items-center'>
            <div className='px-2 text-center font-semibold text-gray-500'>START</div>
            <div className={`flex bg-white items-center border-gray-200 border justify-center mr-2 rounded ${isOverAll ? "" : "date-box"}`}>
              <img src={calendar} style={{ width: 14 }} alt='calender' className=' ml-3 mr-2'/>
              <DatePicker 
                onChange={(e) => changeDates(e, 'startDate')}
                selected={start_date}
                dateFormat="dd/MMM/yyyy"
                isClearable={!isSelectedDateContractStartDate}
                showYearDropdown
                showMonthDropdown
                className={`date-range border-gray-200 ${isOverAll ? "text-gray-300" : "cursor-pointer text-gray-500"}`}
                minDate={contractStartDate}
                maxDate={end_date}
                disabled={isOverAll}
              />
            </div>
          </div>
          <div className='flex items-center' >
            <div className='pr-2 pl-4 text-center font-semibold text-gray-500'>END</div>
            <div className={`flex bg-white items-center border-gray-200 border justify-center mr-2 rounded ${isOverAll ? "" : "date-box"}`}>
              <img src={calendar} style={{ width: 14 }} alt='calender' className=' ml-3 mr-2'/>
              <DatePicker
                onChange={(e) => changeDates(e, 'endDate')}
                selected={end_date}
                dateFormat="dd/MMM/yyyy"
                isClearable={!isSelectedDateContractEndDate}
                showYearDropdown
                showMonthDropdown
                className={`date-range border-gray-200 ${isOverAll ? "text-gray-300" : "cursor-pointer text-gray-500"}`}
                minDate={start_date}
                maxDate={contractEndDate}
                disabled={isOverAll}
              />
            </div>
          </div>
          <button
              onClick={(e)=> changeDates(e, 'reset')}
              className={`${resetButtonClass} ${isOverAll ? resetButtonDisabledClass : ''}`}
              disabled={isOverAll}
            >
              RESET
          </button>
        </div>
      </div>
      {isOverAll && <div className='flex justify-end'>
        <div className='flex mr-44 mt-2'>
          <img src={exclametry_red_dark} className='h-3 w-3 mr-1'></img>
          <p className='text-red-600 font-heavy text-xs mb-0'>Dates can not be edited in the overall tab</p>
        </div>
      </div>}
    </>
  )
}

export default DateRangePicker
